import React, { useState, useEffect } from 'react'
import {Row,Col,Form,Button} from 'react-bootstrap'
import Card from '../../../components/Card'
import ToastNotification from '../../../components/Toast';
import { toast } from 'react-toastify';
import { API_USERS_SIGNUP, API_SIGNUP_EMAIL_SEND_CODE, API_SIGNUP_EMAIL_VERIFY_CODE } from '../../../service/url';
import { postApiCall } from '../../../service/httpCall';
import { useNavigate, useParams } from 'react-router-dom';
import RenderUserAccessRolesList from '../../../components/partials/components/user-access-roles-list';
import { getUserCreateAccessRoleLabel } from '../../../utilities/setting';
import { ROUTES } from '../../../utilities/constant';
import { useAuth, errorCheck } from '../auth/auth-utils';
import { validateEmail } from '../../../utilities/helpers';

const CallCentreUserCreate = () => {

   const navigate = useNavigate();
   const params = useParams();
   const { checkAuth } = useAuth();
   const [callCentreId, setCallCentreId] = useState(undefined);
   const [name, setName] = useState('');
   const [username, setUsername] = useState('');
   const [email, setEmail] = useState('');
   const [password, setPassword] = useState('');
   const [confirmPassword, setConfirmPassword] = useState('');
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [activeUserAccessRole, setActiveUserAccessRole] = useState(undefined);
   const [userAccessRoles, setUserAccessRoles] = useState([]);
   const [emailError, setEmailError] = useState("");
   const [usernameError, setUsernameError] = useState("");
   const [nameError, setNameError] = useState("");
   const [signupEmailOtp, setSignupEmailOtp] = useState("");
   const [signupEmailToken, setSignupEmailToken] = useState("");
   const [emailVerifiedForCreate, setEmailVerifiedForCreate] = useState(false);
   const [signupEmailBusy, setSignupEmailBusy] = useState(false);
   

   useEffect( () => {

    setCallCentreId(params.id);

    getUserCreateAccessRoleLabel()
      .then((resp) => {
        if (resp?.length) {
          setUserAccessRoles(resp);
          setActiveUserAccessRole(resp[0].value);
        }
      })
      .catch(onError);

   }, []);

   useEffect(() => {
      checkAuth(setToastProps, setShowToast)
    }, []);


   // useEffect( () => {

   //    if(toastProps){
   //       setShowToast(true);
   //    }

   // }, [toastProps]);


   async function sendSignupEmailCode() {
      if (!email.trim() || validateEmail(email)) {
         toast.error("Enter a valid email before sending a code.");
         return;
      }
      setSignupEmailBusy(true);
      try {
         await postApiCall(API_SIGNUP_EMAIL_SEND_CODE, { email: email.trim() });
         setSignupEmailToken("");
         setEmailVerifiedForCreate(false);
         toast.success("Verification code sent. Check the inbox for this email.");
      } catch (err) {
         toast.error(typeof err === "string" ? err : "Could not send verification code");
      } finally {
         setSignupEmailBusy(false);
      }
   }

   async function verifySignupEmailOtp() {
      if (!email.trim() || validateEmail(email)) {
         toast.error("Enter a valid email.");
         return;
      }
      if (!signupEmailOtp || signupEmailOtp.length !== 6) {
         toast.error("Enter the 6-digit code from the email.");
         return;
      }
      setSignupEmailBusy(true);
      try {
         const data = await postApiCall(API_SIGNUP_EMAIL_VERIFY_CODE, {
            email: email.trim(),
            otp: signupEmailOtp.trim(),
         });
         if (data?.signupEmailToken) {
            setSignupEmailToken(data.signupEmailToken);
            setEmailVerifiedForCreate(true);
            toast.success("Email verified. You can create the user now.");
         } else {
            toast.error("Unexpected response from server");
         }
      } catch (err) {
         toast.error(typeof err === "string" ? err : "Verification failed");
         setEmailVerifiedForCreate(false);
         setSignupEmailToken("");
      } finally {
         setSignupEmailBusy(false);
      }
   }


   function validateForm(){

      let valid = true;

      if(!validateUsername(username)){
         valid = false;
         if(!username.trim()){
            toast.warning("Username required")
         } else {
            toast.warning(usernameError || "Invalid username format")
         }
      }
      if(!validateName(name)){
         valid = false;
         if(!name.trim()){
            toast.warning("Name required")
         } else {
            toast.warning(nameError || "Invalid name format")
         }
      }
      if(!email.trim()){
         valid = false;
         toast.warning("Email required")
      }
      else if(!password.trim()){
         valid = false;
         toast.warning("Password required")
      }
      else if(password.trim().length < 6){
         valid = false;
         toast.warning("Password must be of minimum 6 characters")
      }
      else if(!confirmPassword.trim()){
         valid = false;
         toast.warning("Confirm password required")
      }
      else if(password.trim() != confirmPassword.trim()){
         valid = false;
         toast.warning("Password and confirm password not matching")
      }
      else if (validateEmail(email)) {
         valid = false;
         toast.warning(validateEmail(email) || "Invalid email");
      }
      else if (!emailVerifiedForCreate || !signupEmailToken) {
         valid = false;
         toast.warning("Verify this email first: Send code, enter OTP, then Verify OTP.");
      }

      return valid;

   }

   async function submitForm(){

      setButtonDisable(true);

      if(!validateForm()){
         setButtonDisable(false);
         return;
      }

      const params = { username, password, role: activeUserAccessRole, name, email, created_by: callCentreId, signup_email_token: signupEmailToken };

      postApiCall(API_USERS_SIGNUP, params)
      .then(onUserCreateSuccess)
      .catch(onUserCreateError);

   }

   function onUserCreateSuccess(resp){
      toast.success("User created successfully.")
      setTimeout( () => {
         const callCentreUsersListPath = ROUTES.CALL_CENTRES.USERS.LIST.replace(':id', callCentreId);
         navigate(`/${callCentreUsersListPath}`);
      }, 1500);
   }

   function onUserCreateError(err){
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        setButtonDisable(false);
        toast.warning(JSON.stringify(err))
      }
   }

   function onError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
       errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      console.log(err)
    }
   }

   const validateUsername = (value) => {
     const trimmedValue = value.trim();
     if (!trimmedValue) {
       setUsernameError("Username is required");
       return false;
     }
     if (trimmedValue.length < 3 || trimmedValue.length > 50) {
       setUsernameError("Username must be between 3 and 50 characters");
       return false;
     }
     if (!/^[a-zA-Z0-9_]+$/.test(trimmedValue)) {
       setUsernameError("Username can only contain letters, numbers, and underscores");
       return false;
     }
     setUsernameError("");
     return true;
   };

   const validateName = (value) => {
     const trimmedValue = value.trim();
     if (!trimmedValue) {
       setNameError("Name is required");
       return false;
     }
     if (trimmedValue.length < 2 || trimmedValue.length > 100) {
       setNameError("Name must be between 2 and 100 characters");
       return false;
     }
     if (!/^[a-zA-Z0-9_ ]+$/.test(trimmedValue)) {
       setNameError("Name can only contain letters, numbers, underscores, and spaces");
       return false;
     }
     setNameError("");
     return true;
   };
     
 const validateEmailField = (value) => {
   setEmailError(validateEmail(value));
 };
     
   return(
      <>
        <div>
            <Row>
               <Col xl="12" lg="12">
                  <Card>
                     <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">New User Information</h4>
                           <RenderUserAccessRolesList activeUserAccessRole={activeUserAccessRole} />
                        </div>
                     </Card.Header>
                     <Card.Body>
                        <div className="new-user-info">
                           <form>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="username">User Name:</Form.Label>
                                    <Form.Control 
                                       type="text" 
                                       id="username" 
                                       maxLength={50} 
                                       value={username} 
                                       onChange={e => {
                                          setUsername(e.target.value);
                                          validateUsername(e.target.value);
                                       }}
                                       onBlur={e => validateUsername(e.target.value)}
                                       className={usernameError ? "is-invalid" : ""}
                                       required 
                                    />
                                    {usernameError && <div className="invalid-feedback">{usernameError}</div>}
                                 </Form.Group>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="name">Full Name:</Form.Label>
                                    <Form.Control 
                                       type="text"  
                                       id="name" 
                                       maxLength={100} 
                                       value={name} 
                                       onChange={e => {
                                          setName(e.target.value);
                                          validateName(e.target.value);
                                       }}
                                       onBlur={e => validateName(e.target.value)}
                                       className={nameError ? "is-invalid" : ""}
                                       required 
                                    />
                                    {nameError && <div className="invalid-feedback">{nameError}</div>}
                                 </Form.Group>
                              </div>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="email">Email:</Form.Label>
                                    <Form.Control type="email"  id="email" maxLength={100} value={email}
                                    onChange={(e) => {
                                       const v = e.target.value;
                                       setEmail(v);
                                       validateEmailField(v);
                                       setSignupEmailToken("");
                                       setSignupEmailOtp("");
                                       setEmailVerifiedForCreate(false);
                                     }}
                                      required
                                    />
                                    {emailError && <span className="text-danger">{emailError}</span>}
                                    <div className="d-flex flex-wrap align-items-end gap-2 mt-2">
                                       <Form.Control
                                          type="text"
                                          inputMode="numeric"
                                          placeholder="6-digit code"
                                          maxLength={6}
                                          style={{ maxWidth: "140px" }}
                                          value={signupEmailOtp}
                                          onChange={(e) => setSignupEmailOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                                          disabled={signupEmailBusy}
                                       />
                                       <Button type="button" variant="outline-primary" size="sm" disabled={signupEmailBusy || !email.trim() || !!validateEmail(email)} onClick={sendSignupEmailCode}>Send code</Button>
                                       <Button type="button" variant="outline-success" size="sm" disabled={signupEmailBusy || signupEmailOtp.length !== 6} onClick={verifySignupEmailOtp}>Verify OTP</Button>
                                       {emailVerifiedForCreate && <span className="text-success small">Email verified</span>}
                                    </div>
                                 </Form.Group>
                              </div>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="pass">Password:</Form.Label>
                                    <Form.Control type="password"  id="pass" maxLength={100} value={password} onChange={e => setPassword(e.target.value)} required />
                                 </Form.Group>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="rpass">Confirm Password:</Form.Label>
                                    <Form.Control type="password"  id="rpass" maxLength={100} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
                                 </Form.Group>
                              </div>
                              <hr/>
                              <Button onClick={async() => {submitForm()}} type="button" variant="btn btn-primary" disabled={buttonDisable}>
                                 Add New User &nbsp;
                                 {
                                    buttonDisable ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></>
                                 }
                              </Button>
                           </form>
                        </div>
                     </Card.Body>
                  </Card>
               </Col>
            </Row>
         </div>

         {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

      </>
  )

}

export default CallCentreUserCreate;